import Phaser from 'phaser';

const BG_OUTER = 0x1e1b2e;
const BG_INNER = 0x3b2d5c;
const SLASH_COLOR = 0xffffff;
const STROKE = 0x0a0f1f;

export function drawClaws(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const slashLen = r * 1.15;
  const slashHalf = slashLen / 2;
  const slashW = Math.max(3, r * 0.16);
  const angle = -Math.PI / 4;
  const spacing = r * 0.35;
  const perpX = Math.cos(angle + Math.PI / 2);
  const perpY = Math.sin(angle + Math.PI / 2);
  const dirX = Math.cos(angle);
  const dirY = Math.sin(angle);

  for (let i = -1; i <= 1; i++) {
    const cx = perpX * spacing * i;
    const cy = perpY * spacing * i;
    const p0x = cx - dirX * slashHalf;
    const p0y = cy - dirY * slashHalf;
    const p1x = cx + dirX * slashHalf;
    const p1y = cy + dirY * slashHalf;
    drawThickLine(g, p0x, p0y, p1x, p1y, slashW, SLASH_COLOR, STROKE, Math.max(1, Math.floor(slashW * 0.25)));
  }
}

function drawThickLine(
  g: Phaser.GameObjects.Graphics,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  width: number,
  fill: number,
  stroke: number,
  strokeW: number,
) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const len = Math.hypot(dx, dy);
  if (len === 0) return;
  const nx = -dy / len;
  const ny = dx / len;
  const hx = (nx * width) / 2;
  const hy = (ny * width) / 2;
  const p0 = { x: x1 + hx, y: y1 + hy };
  const p1 = { x: x2 + hx, y: y2 + hy };
  const p2 = { x: x2 - hx, y: y2 - hy };
  const p3 = { x: x1 - hx, y: y1 - hy };
  g.fillStyle(fill, 1);
  g.lineStyle(strokeW, stroke, 1);
  g.beginPath();
  g.moveTo(p0.x, p0.y);
  g.lineTo(p1.x, p1.y);
  g.lineTo(p2.x, p2.y);
  g.lineTo(p3.x, p3.y);
  g.closePath();
  g.fillPath();
  g.strokePath();
}
